import SocialEvanoteIcon from 'Components/common/assets/svgIcons/SocialEvanoteIcon';
import React from 'react';



type Props = {
  url: string
  title: string
};

const EverNote = function EverNote(props: Props) {
  const { title, url } = props;
  return (
    <span style={{ marginRight: '5px' }} className="evanote-icon">
      <a
        href={
          `https://www.evernote.com/clip.action?title=${encodeURIComponent(title)
          } - via @xiqinc`
          + `&url=${encodeURIComponent(url)}`
        }
        target="_blank"
        rel="noopener noreferrer"
        data-share-type="evernote_share"
      >

        <SocialEvanoteIcon />

      </a>
    </span>
  );
};

export default EverNote;
